module.exports = __webpack_public_path__ + "static/img/boxImg4.e3768fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boxImg4.png
// module id = 3lof
// module chunks = 2